import { Localization } from "./Localization";
import { CURRENTLY_EXECUTING_SCRIPT_BASE_URL } from "@cxp-shared/resource-loader/CurrentlyExecutingScriptInfo";
import { resolveFormPlaceholders } from "./resolveFormPlaceholders";
import { Logger } from "./Logger";
import { createFormLoaderFactory } from "./CreateFormLoaderFactory";
import { createFormPlaceholderClass } from "./FormPlaceholder";
import { getExternalConfiguration } from "./GetExternalConfiguration";
import { createForm } from "./CreateForm";
import { renderFailedSubmission, renderSuccessfulSubmission } from "./ShowFeedback";
import { fillLookupFromSearch } from "./Lookups/lookupSearchHelper";
// load CJO forms
(function () {
    Localization.Initialize(CURRENTLY_EXECUTING_SCRIPT_BASE_URL, navigator.language);
    whenLoaded().then(function () {
        var externalConfiguration = getExternalConfiguration();
        if (!externalConfiguration.formLoadingStarted) {
            externalConfiguration.formLoadingStarted = true;
            var logger = new Logger();
            var formLoaderFactory = createFormLoaderFactory(logger);
            resolveFormPlaceholders(logger, formLoaderFactory);
        }
    });
})();
function whenLoaded() {
    return new Promise(function (resolve) {
        if (document.readyState !== "loading") {
            resolve();
        }
        else {
            var listener_1 = function () {
                document.removeEventListener("DOMContentLoaded", listener_1);
                resolve();
            };
            document.addEventListener("DOMContentLoaded", listener_1);
        }
    });
}
var ExternalApi = /** @class */ (function () {
    function ExternalApi() {
    }
    Object.defineProperty(ExternalApi, "FormPlaceholder", {
        /**
         * React is an *optional* dependency of FormLoader (see webpack.config.js `externals`).
         * Getter throws when a consumer actually tries to use FormPlaceholder without window.React present.
         */
        get: function () {
            var react = window.React;
            if (!react) {
                throw new Error("d365mktforms.FormPlaceholder requires React to be loaded as a global variable " +
                    "(window.React) on the host page BEFORE FormLoader.bundle.js. See " +
                    "https://go.microsoft.com/fwlink/?linkid=2224838#injecting-a-marketing-form-into-a-react-application");
            }
            if (!ExternalApi.formPlaceholderClass) {
                ExternalApi.formPlaceholderClass = createFormPlaceholderClass(react);
            }
            return ExternalApi.formPlaceholderClass;
        },
        enumerable: false,
        configurable: true
    });
    ExternalApi.createForm = createForm;
    ExternalApi.renderFailedSubmission = renderFailedSubmission;
    ExternalApi.renderSuccessfulSubmission = renderSuccessfulSubmission;
    ExternalApi.fillLookupFromSearch = fillLookupFromSearch;
    return ExternalApi;
}());
export { ExternalApi };
